// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1ooLs","form":"styles_form__JYY4H"};